"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteFactory = void 0;
const NoteType_1 = require("./lib/NoteType");
const types_1 = require("./types");
const regex_1 = require("../../common/regex");
class NoteFactory {
    static fromCourseValue(raw, strict = true) {
        switch (raw) {
            case NoteType_1.NoteType.Blank:
                return new types_1.BlankNote();
            case NoteType_1.NoteType.Don:
                return new types_1.Don();
            case NoteType_1.NoteType.Ka:
                return new types_1.Ka();
            case NoteType_1.NoteType.DON:
                return new types_1.BigDon();
            case NoteType_1.NoteType.KA:
                return new types_1.BigKa();
            case NoteType_1.NoteType.Drumroll:
                return new types_1.Drumroll();
            case NoteType_1.NoteType.DRUMROLL:
                return new types_1.BigDrumroll();
            case NoteType_1.NoteType.Balloon:
                return new types_1.Balloon();
            case NoteType_1.NoteType.DrumrollEnd:
                return new types_1.DrumrollEnd();
            case NoteType_1.NoteType.Kusudama:
                return new types_1.Kusudama();
            case NoteType_1.NoteType.MultiDon:
                return new types_1.MultiDon();
            case NoteType_1.NoteType.MultiKa:
                return new types_1.MultiKa();
            case NoteType_1.NoteType.ADLIB:
                return new types_1.MultiKa();
            case NoteType_1.NoteType.MeasureEnd:
                return new types_1.MeasureEnd();
        }
        if (raw.match(regex_1.NOTE_REGEX)) {
            return new types_1.BlankNote();
        }
        if (strict) {
            throw new TypeError(`Unsupported note type: ${raw}`);
        }
    }
}
exports.NoteFactory = NoteFactory;
